/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Helmet } from "react-helmet"

import Header from "./header"
import "./layout.css"
import Footer from "./footer"
import Banner from "./banner"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  React.useEffect(() => {
    const els = document.querySelectorAll('.google-auto-placed');
    els.forEach((el, idx) => {
      if (idx !== 0) {
        el.style.display = 'initial';
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link rel="preconnect" href="https://cdn.shopify.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap"
          rel="stylesheet"
        />
        <meta
          name="google-site-verification"
          content="dYS--v6uICzU5MbwzFHYSsBj_70sW7zoBm7ew66m7SQ"
        />
        <meta name='impact-site-verification' value='6277b14a-198e-4822-875c-48ae91b09a38'></meta>
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3040097998038075"
          crossorigin="anonymous"
        ></script>
        
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      </Helmet>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      {/* <Banner /> */}
      <div className="container mx-auto">
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
